import { injectable } from 'inversify';
import { ReportConfig } from './ReportConfig';
import type { IReportConfig, IReportConfigProvider } from './interfaces';

@injectable()
/**
 * Provides the configuration for generating reports.
 * This is a stub implementation of the real report configuration provider.
 */
export class ReportConfigProvider implements IReportConfigProvider {
  public getReportConfig(): Promise<IReportConfig> {
    return Promise.resolve(new ReportConfig({ entries: new Map(), imagesDPI: 300, procedureName: 'Stub config' }));
  }
}
